import { API_BASE_URL } from '../config';

export async function searchAlbums(query: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/public/album/search?q=${encodeURIComponent(query)}`);
    if (!response.ok) {
      throw new Error('Failed to search albums');
    }
    return await response.json();
  } catch (error) {
    console.error('Error searching albums:', error);
    throw error;
  }
}

export async function fetchAlbum(albumId: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/public/album/${albumId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch album details');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching album:', error);
    throw error;
  }
}

export async function fetchAlbumTracks(albumId: string) {
  try {
    // Use authenticated bundle endpoint for album tracks
    const token = localStorage.getItem("access_token");
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_BASE_URL}/bundle/album/${albumId}`, {
      headers,
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('Unauthorized: Please log in to access album tracks');
      }
      throw new Error('Failed to fetch album tracks');
    }
    
    const data = await response.json();
    // Bundle endpoint returns { bundle_type, album_id, tracks }
    return {
      tracks: data.tracks || [],
      ...data
    };
  } catch (error) {
    console.error('Error fetching album tracks:', error);
    throw error;
  }
} 